// packages/eden-table/src/components/CardView/Context.jsx
import { createContext } from "react";
var CardViewContext = createContext({
  cellDecorator: (props) => props
});
var Context_default = CardViewContext;
export {
  Context_default as default
};
